import { gql, useQuery } from '@apollo/client'

// Типы согласно customer-app
export type LoyaltyStatusLevelInfo = {
  name: string
  description: string
  threshold: number
  preference: string
  preferencePostfix: string
}

export type NextLoyaltyStatusLevel = LoyaltyStatusLevelInfo & {
  needToNextLevel: number
  nextCalcDate: number
}

export type LoyaltyStatusInfo = {
  id: string
  name: string
  currentValue: number
  levels: LoyaltyStatusLevelInfo[]
  currentLevel: LoyaltyStatusLevelInfo | null
  nextLevel: NextLoyaltyStatusLevel | null
  returnAmount: number
  saleAmount?: number
}

/**
 * GraphQL запрос для получения информации об уровнях лояльности
 * Поля скопированы из customer-app/src/graphql/query/customer/getLoyaltyLevelInfo.gql.ts
 */
const GQL_QUERY_GET_LOYALTY_LEVEL_INFO = gql`
  query getLoyaltyLevelInfo {
    getLoyaltyLevelInfo {
      id
      name
      currentValue
      levels {
        name
        description
        threshold
        preference
        preferencePostfix
      }
      currentLevel {
        name
        description
        threshold
        preference
        preferencePostfix
      }
      nextLevel {
        name
        description
        threshold
        preference
        preferencePostfix
        needToNextLevel
        nextCalcDate
      }
      returnAmount
      saleAmount
    }
  }
`

type GetLoyaltyLevelInfoQueryResult = {
  getLoyaltyLevelInfo: LoyaltyStatusInfo | null
}

interface UseFetchLoyaltyLevelInfoOptions {
  skip?: boolean
}

/**
 * Хук для получения информации об уровнях лояльности пользователя
 * Копия логики из customer-app/src/graphql/query/customer/getLoyaltyLevelInfo.gql.ts
 */
export function useFetchLoyaltyLevelInfo (options: UseFetchLoyaltyLevelInfoOptions = {}) {
  const { data, loading, error, refetch } = useQuery<GetLoyaltyLevelInfoQueryResult>(
    GQL_QUERY_GET_LOYALTY_LEVEL_INFO,
    {
      fetchPolicy: 'cache-and-network',
      skip: options.skip
    }
  )

  return {
    loyaltyStatusInfo: data?.getLoyaltyLevelInfo,
    loading,
    error,
    refetch
  }
}